// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"748":"f7d839ed","872":"21b38053"}[chunkId] + ".chunk.css";
};